import { products } from '../data/products';

export const getProducts = () => products;

export const saveProducts = (list) => {
  localStorage.setItem('adminProducts', JSON.stringify(list));
};
